module.exports = __webpack_public_path__ + "media/bowls/bowl-with-food2-f623eb05.svg";